export default "__VITE_ASSET__BEtcXaje__"